module.exports = __webpack_public_path__ + "static/media/extract_logo.23a2ac52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/extract_logo.svg
// module id = 170
// module chunks = 0